import React, { useEffect, useState } from 'react';
import { ForgotPasswordView, ForgotPasswordViewProps } from './ForgotPassword.view';
import { RegisterOptions, useForm } from 'react-hook-form';
import { SendPasswordResetEmailMutationFn, SendPasswordResetEmailMutationVariables } from '../../../models/graphql';
import { FormOptions, ValidationPatterns } from '../../../constants/form';
import { ValidationMessages } from '../../../constants/validation-messages';
import { ApolloError } from '@apollo/client';
import { CheckEmail } from '../CheckEmail';
import { showToast } from '../../../helpers/showToast';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { SubmitHandler, UseFormProps } from 'react-hook-form/dist/types/form';

export type ForgotPasswordControllerProps = Omit<
  ForgotPasswordViewProps,
  'emailRules' | 'onSubmit' | 'formInstance'
> & {
  // extend your ForgotPasswordViewProps
  sendResetPassword: SendPasswordResetEmailMutationFn;
  resetSent: boolean;
};

const defaultFormValues: SendPasswordResetEmailMutationVariables = {
  email: ''
};

export const ForgotPasswordController = (props: ForgotPasswordControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const [resetSent, setResetSent] = useState<boolean>(false);
  const [submittedEmail, setSubmittedEmail] = useState<string>('');
  const formOptions = {
    ...FormOptions
  } as UseFormProps<SendPasswordResetEmailMutationVariables>;
  const formInstance = useForm<SendPasswordResetEmailMutationVariables>({
    ...formOptions,
    defaultValues: defaultFormValues
  });
  const emailRules: RegisterOptions = {
    required: ValidationMessages.email.required,
    pattern: {
      value: ValidationPatterns.email,
      message: ValidationMessages.email.invalid
    }
  };

  useEffect(() => {
    if (props.resetSent !== resetSent) {
      setResetSent(oldVal => {
        if (oldVal) {
          setSubmittedEmail('');
        }
        return !oldVal;
      });
    }
    // TODO-FIX-TS-WARNINGS
    // eslint-disable-next-line
  }, [props.resetSent]);

  const onSubmit: SubmitHandler<SendPasswordResetEmailMutationVariables> = async (
    data: SendPasswordResetEmailMutationVariables
  ) => {
    try {
      setSubmittedEmail(data.email);
      await props.sendResetPassword({ variables: data });
    } catch (error) {
      showToast({
        severity: 'error',
        summary: 'Reset Password Error',
        detail: remapApolloErrors(error as ApolloError)
      });
    }
  };

  const viewProps: ForgotPasswordViewProps = { ...props, formInstance, emailRules, onSubmit };
  return resetSent ? (
    <CheckEmail email={submittedEmail} setResetSent={setResetSent} />
  ) : (
    <ForgotPasswordView {...viewProps} />
  );
};
